import React from "react";
import { CloseIcon, PostIcon } from "@/components/icons";
import { getStageConfig } from "./stageConfig";

interface ReviewHeaderProps {
  onClose: () => void;
  title: string;
  currentIndex: number;
  total: number;
  stage?: string;
  /** Number of posts the current item is used in. > 0 shows an "in a post" pill. */
  inPostCount?: number;
}

export const ReviewHeader: React.FC<ReviewHeaderProps> = ({
  onClose,
  title,
  currentIndex,
  total,
  stage,
  inPostCount = 0,
}) => {
  const { colors, label } = getStageConfig(stage);

  return (
    <div className="shrink-0 flex items-center justify-between px-4 py-3 bg-black/90 border-b border-gray-800">
      <div className="flex items-center gap-4">
        <button
          onClick={onClose}
          className="p-2 text-white hover:bg-gray-800 rounded-lg transition-colors"
        >
          <CloseIcon className="w-6 h-6" />
        </button>
        <div>
          <h2 className="text-white font-medium text-lg">{title}</h2>
          <p className="text-gray-400 text-sm">
            {currentIndex + 1} of {total} {title.toLowerCase()}s
          </p>
        </div>
      </div>

      <div className="flex items-center gap-2">
        {inPostCount > 0 && (
          <div className="flex items-center gap-1.5 px-3 py-1.5 rounded-full text-sm font-medium bg-amber-500/20 text-amber-300">
            <PostIcon className="w-4 h-4" />
            {inPostCount > 1 ? `In ${inPostCount} posts` : "In a post"}
          </div>
        )}

        {stage && (
          <div className={`px-3 py-1.5 rounded-full text-sm font-medium ${colors.bg} ${colors.text}`}>
            {label}
          </div>
        )}
      </div>
    </div>
  );
};
